import { makeRequest } from 'utils/requestLogger';

export default (liveID) =>
  makeRequest('get', `/api/live_discussions/${liveID}/get_all_student_notes`);



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/getAllStudentNotes.js